import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import COLORS from '../../../common/colors';
import FacebookIcon from '../../chrome/elements/icons/facebookIcon';
import TwitterIcon from '../../chrome/elements/icons/twitterIcon';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const _getLocalStore = (name) => {
    try {
        return JSON.parse(localStorage.getItem(name));
    } catch (err) {
        return null;
    }
};

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
        const { session } = props;

        let currentCurrency = 'INR';
        const localStoreCurrency = _getLocalStore('currentCurrency');
        if (localStoreCurrency) {
            currentCurrency = localStoreCurrency;
        } else if (session && session.currentCurrency) {
            currentCurrency = session.currentCurrency;
        } else if (session && session.country) {
            currentCurrency = session.country;
        }
        if (currentCurrency === 'INR' || currentCurrency === 'IN') {
            this.state = {
                currency: 'INR',
                toggle: false,
            };
        } else {
            this.state = {
                currency: 'USD',
                toggle: true,
            };
        }
    }


    render() {
        return (
            <Container className="footer" id="footer">
                <Row className="footer-top  d-flex" style={{ paddingTop: '2rem', paddingBottom: '2rem'}}>
                    <Col xs="12" md="12" lg="12" sm="12"  className="d-flex justify-content-center align-self-center footer-height-for-mobile  ">
                        <Row className="footer-column flex-wg-footer">

                                {this.props.subdomain === "hdfc" ? 
                                <img height={"40px"} alt={'GiveIndia Logo'} src={`${config.cdnUrl}/static/images/giveindia-logo-v2-small.jpg`} /> :
                                <img height={"40px"} alt={'GiveIndia Logo'} src={`${config.cdnUrl}/static/images/wg/workplace-giving-color.jpg`} />}
                                <div className="flex-wg-footer footer-column-2">
                                    <div><a href="/aboutus" className="footer-menu-link-2" target="_blank"> About Us </a></div>
                                    <div><a href={`${this.props.tenantConfig.faq ?'/company-faqs':'/faqs'}`} className="footer-menu-link-2" target="_blank"> FAQs </a></div>
                                    <div><a href="/contactus" className="footer-menu-link-2" target="_blank"> Contact Us </a></div>
                                </div>
                                
                            <style>{
                                `
                                .flex-wg-footer {
                                    display: flex;
                                    justify-content: space-between;
                                    padding: 0 20px;
                                    align-items: center;
                                } 

                                .footer-column-2 {
                                    width: 40%
                                }

                                .footer-menu-link-2 {
                                    color: #708099
                                }

                                .footer-menu-link-2:hover {
                                    text-decoration: none;
                                    color: #708099
                                }
                                @media(max-width: 768px) {
                                    .footer-column-2 {
                                        width: 100%
                                    }
                                    .flex-wg-footer {
                                        justify-content: center; 
                                        padding: 10px 0 0 0;
                                    }
                                    .footer-menu-link-2 {
                                        padding: 10px;
                                    }
                                }
                                `
                                }</style>

                        </Row>
                    </Col>
                </Row>

                <Row className="footer-bottom">
                    <div className="footer-bottom-left">
                        <p >© GiveIndia &nbsp; &nbsp; &nbsp; &nbsp; Donations through this platform are tax exempted under 80G & 501(c)(3)</p>
                        <style jsx>{
                            `
								.footer-exempted-span {
									display: inline-block;
                                    padding-bottom: 0;
                                    padding-top: 10px;
									width: 100%;
                                }

							`
                        }
                        </style>


                    </div>
                    <div className="footer-bottom-right">
						<span>
							<a className="no-hover-a" href="/terms"><p>Terms</p></a>
						</span>
                        <span>
							<a className="no-hover-a" href="/privacy"><p>Privacy Policy</p></a>
						</span>
                        <span>
							<a href="/sitemap"><p>Site Map</p></a>
						</span>
                        <span>
							<a rel="noopener noreferrer" href="https://www.facebook.com/GiveIndia/" target="_blank">
								<FacebookIcon
                                    style={{ display: 'flex', alignItems: 'center' }}
                                    size={20}
                                    color={`${COLORS.giveMidGrey}`}
                                />
							</a>
						</span>
                        <span>
							<a rel="noopener noreferrer" href="https://twitter.com/giveindia/" target="_blank">
								<TwitterIcon
                                    style={{ display: 'flex', alignItems: 'center' }}
                                    size={20}
                                    color={`${COLORS.giveMidGrey}`}
                                />
							</a>
						</span>
                    </div>
                </Row>
            </Container>
        );
    }
}
